import { render } from "./Redoc.vue?vue&type=template&id=e4cdab92"
import script from "./Redoc.vue?vue&type=script&lang=js"
export * from "./Redoc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__